var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$isAgent())?_c('appbar'):_c('appbarAgent'),_c('v-main',[_c('v-container',{staticClass:"mx-auto",staticStyle:{"max-width":"1024px"}},[_c('router-view'),(!_vm.$isAgent())?_c('footerIns'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }